<div class="page-container">
  <div *ngIf="showToastMessage && eventStarted" class="toast-info">
    <div>    
      Scan to check students in/out instantly, or use the list below.
    </div>
    <fa-icon class="toast-info-close" (click)="onCloseToast()" [icon]="['fas', 'close']"></fa-icon>
  </div>
  <div class="scheduled-hero-event-title-bar">
    <div class="scheduled-hero-event-title-info">
      <div class="scheduled-event-time">
        {{ getCalendarDayDate() }}
      </div>
      <div class="schedule-event-info-display-container">
        <div class="schedule-event-info-item">
          <span class="schedule-event-info-label"> Event ID </span>
          <span class="schedule-event-info-value">
            &nbsp;
            {{ scheduledHeroEvent.heroEvent.eventRefId }}
          </span>
        </div>
        <div class="schedule-event-info-item">
          <span class="schedule-event-info-label"> Category </span>
          <span class="schedule-event-info-value">
            &nbsp;
            {{ scheduledHeroEvent.heroEvent.eventCategory.name }}
          </span>
        </div>
        <div *ngIf="!scheduledHeroEvent.startTime" class="schedule-event-info-item">
          <span class="schedule-event-info-label"> Time </span>
          <span class="schedule-event-info-value">
            &nbsp;
            {{ scheduledHeroEvent.heroEvent.startTime }}
          </span>
        </div>
        <div class="schedule-event-info-item">
          <span class="schedule-event-info-label"> Recurrence </span>
          <span class="schedule-event-info-value">
            &nbsp;
            {{ scheduledHeroEvent.heroEvent.recurrence }}
          </span>
        </div>
        <div *ngIf="scheduledHeroEvent.startTime" class="schedule-event-info-item">
          <span class="schedule-event-info-label"> Start Time </span>
          <span class="schedule-event-info-value">
            &nbsp;
            {{ DateUtil.convertToDisplayTime(scheduledHeroEvent.startTime) }}
          </span>
        </div><div *ngIf="scheduledHeroEvent.endTime" class="schedule-event-info-item">
          <span class="schedule-event-info-label"> End Time </span>
          <span class="schedule-event-info-value">
            &nbsp;
            {{ DateUtil.convertToDisplayTime(scheduledHeroEvent.endTime) }}
          </span>
        </div>
      </div>
    </div>

    <div class="schedule-event-action-container">
      <button
        mat-flat-button
        color="primary"
        class="start-scheduled-event-button"
        (click)="startEvent()"
        *ngIf="!scheduledHeroEvent.startTime">
        Start Event
      </button>
      <button
        mat-flat-button
        color="primary"
        class="end-scheduled-event-button"
        (click)="endEvent()"
        *ngIf="scheduledHeroEvent.startTime && !scheduledHeroEvent.endTime">
        End Event
      </button>
      <button
        mat-flat-button
        class="border-button"
        (click)="startEvent()"
        *ngIf="scheduledHeroEvent.startTime && scheduledHeroEvent.endTime">
        Reopen Event
      </button>
    </div>
  </div>
  <div class="scheduled-hero-event-action-bar">
    <mat-form-field>
      <input matInput placeholder="Search" [formControl]="searchControl" />
    </mat-form-field>
    <div >
      <button
        mat-flat-button
        class="action-button"
        (click)="showAddStudentModal()"
        *ngIf="scheduledHeroEvent.heroEvent.openToAll && scheduledHeroEvent.startTime && !scheduledHeroEvent.endTime">
        <fa-icon [icon]="'plus'"/> &nbsp; STUDENTS
      </button>
      <button 
        #scanButton
        mat-flat-button
        color="primary"
        class="scan-button"
        (click)="showScanStudentModal()"
        [disabled]="!eventStarted"
      >
        EXT STUDENT ID
      </button>
    </div>
    
  </div>
  <app-scheduled-hero-event-view-student-table
    [isLoading]="isLoading"
    [dataArr]="filteredEventStudents"
    [started]="scheduledHeroEvent.startTime && !scheduledHeroEvent.endTime"
    [scheduledHeroEventId]="scheduledHeroEvent.id"
    [allowMultipleEntries]="scheduledHeroEvent.heroEvent.allowMultipleEntries"
    (updated)="updateStudent($event)"

  >

  </app-scheduled-hero-event-view-student-table>
</div>
